import { render } from "./cluetype.vue?vue&type=template&id=36e5c445"
import script from "./cluetype.vue?vue&type=script&lang=js"
export * from "./cluetype.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__